import { APIResponse, CustomAxiosRequestConfig } from '@/types';
import httpService from '../httpService';
import {
    CorporateSettingInfo,
    CorporateSettingPayload,
    SetSettingsResponse,
    UpdateWhiteListResponse,
} from '@/types/pages/admin/settings';

export function fetchCorporationSettingAPI(corporateId: number): APIResponse<
    CorporateSettingInfo & {
        pp2w_trigger_fields: string;
    }
> {
    return httpService.get(`/corporate/${corporateId}/setting`, {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
}

export function updateCorporationSettingAPI(
    corporateId: number,
    payload: CorporateSettingPayload,
): APIResponse<SetSettingsResponse> {
    return httpService.post(`/corporate/${corporateId}/setting`, payload);
}

export function fetchAssetListAPI(storeId: number): APIResponse<string[]> {
    return httpService.get(`/store/${storeId}/whitelist`, {
        params: {
            record_type: 0,
        },
    });
}

export function uploadAssetListAPI(storeId: number, macList: string[]): APIResponse<UpdateWhiteListResponse> {
    return httpService.patch(`/store/${storeId}/whitelist`, {
        record_type: 0, // 0: Devices | 1: Products | 2: Shelves | 3: Profiles
        keywords: macList,
    });
}
